module.exports = __webpack_public_path__ + "static/media/xbox_logo_b&w_png.48734e65.png";